// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2359":"2d22ebaa","7190":"702693e3","9130":"702693e3"}[chunkId] + ".chunk.css";
};